import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-scroll";
import { navLinks } from "../../data/siteData";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <a className="navbar__logo" href="/" aria-label="byond care">
        <img src="/images/logo.png" alt="byond care" />
      </a>
      <button
        className="navbar__menu-btn"
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        <FaBars />
      </button>
      <ul className={`navbar__links ${open ? "navbar__links--open" : ""}`}>
        {navLinks.map((link) => (
          <li key={link.id}>
            <Link
              to={link.id}
              smooth
              duration={450}
              offset={-70}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to="demo"
        smooth
        duration={450}
        offset={-70}
        className="btn navbar__demo-btn"
        onClick={() => setOpen(false)}
      >
        Book a Demo
      </Link>
    </nav>
  );
}

export default Navbar;
